import { Module } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { LegacyRoute } from '@/modules/legacy/constants';
import { LegacyPathName } from '@/modules/legacy/constants';
import { RouteNames } from '@/modules/legacy/legacy.constants';

const DashboardDetailPage = () =>
  import(
    /* webpackChunkName: "dashboard-detail-page" */ '@/modules/legacy/dashboards/pages/DashboardDetailPage.vue'
  );
const LegacyReportStudioDetailPage = () =>
  import(
    /* webpackChunkName: "legacy-report-studio-detail-page" */ '@/modules/legacy/reportstudio/pages/ReportStudioDetailPage.vue'
  );

const ReportStudioDetailPage = () =>
  import(
    /* webpackChunkName: "report-studio-detail-page1" */ '@/modules/ta/reportstudio/pages/ReportStudioDetailPage.vue'
  );

export const fullFrameLegacyRouter = [
  PageRouteConfig.factory(
    {
      path: `/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: LegacyPathName.REPORTSTUDIOVIEW,
      component: LegacyReportStudioDetailPage,
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/nui/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: 'new_' + LegacyPathName.REPORTSTUDIOVIEW,
      component: ReportStudioDetailPage,
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/fav/nui/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: 'fav_new_' + LegacyPathName.REPORTSTUDIOVIEW,
      component: ReportStudioDetailPage,
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/fav/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: 'fav_' + LegacyPathName.REPORTSTUDIOVIEW,
      component: LegacyReportStudioDetailPage,
      props: {
        isFavorite: true,
      },
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/${LegacyRoute.QUICKREPORT}`,
      name: LegacyPathName.QUICKREPORT,
      component: () =>
        import(
          /* webpackChunkName: "quickreport-legacy-page" */ '@/modules/legacy/quickreport/pages/QuickReportLegacyPage.vue'
        ),
    },
    Module.QUICKREPORT
  ),
];

export const rightFrameLegacyRouter = [
  {
    path: `/${LegacyRoute.DASH}/:id`,
    name: LegacyPathName.DASHBOARDVIEW,
    component: DashboardDetailPage,
  },
  {
    path: `/fav/${LegacyRoute.DASH}/:id`,
    name: 'fav_' + LegacyPathName.DASHBOARDVIEW,
    component: DashboardDetailPage,
    props: {
      isFavorite: true,
    },
  },
];

export const billingRouter = PageRouteConfig.factory(
  [
    {
      path: '/billing',
      name: 'billing',
      component: () =>
        import(
          /* webpackChunkName: "billing-page"*/ '../core/billing/pages/LegacyBillingInfoPage.vue'
        ),
    },
    {
      path: '/billing/address',
      name: 'billingaddress',
      component: () =>
        import(
          /* webpackChunkName: "billingaddress-page"*/ '../core/billing/pages/LegacyBillingAddressPage.vue'
        ),
    },
    {
      path: '/billing/creditcard',
      name: 'billingcreditcard',
      component: () =>
        import(
          /* webpackChunkName: "billingcreditcard-page"*/ './billing/pages/BillingCreditcardPage.vue'
        ),
    },
  ],
  Module.BILLING
);

export const goalsRouteConfig = PageRouteConfig.factory(
  [
    {
      path: `/${LegacyRoute.GOALS}`,
      name: LegacyPathName.GOALS,
      component: () =>
        import(/* webpackChunkName: "goals-page"*/ '@/modules/ta/goal/pages/GoalsPage.vue'),
    },
  ],
  Module.GOAL
);
